import Icon from 'veui/components/Icon'
import { IconBarChartAlt } from 'dls-icons-vue'

Icon.register('bar-chart-alt', IconBarChartAlt)
